import React from 'react';
import { Spin, Flex, Alert } from '@app/ui';
import { useTranslation } from 'react-i18next';
import { useBroadcastsContext } from '../../BroadcastsContext';
import TopSponsorsCard from './TopSponsorsCard';
import { getVerbalMentionPlacementIds } from '../../utils/broadcastsUtils';
import VerbalMentionsTable from './VerbalMentionsTable';

const BroadcastVerbalMentions = () => {
    const { t } = useTranslation('measurement');
    const { filters, isAttributionFiltersReady } = useBroadcastsContext();
    const vmPlacementIds = getVerbalMentionPlacementIds(filters);

    if (
        !isAttributionFiltersReady ||
        filters?.isLoading ||
        Object.values(filters?.placements?.list)?.length === 0 ||
        (Object.values(filters?.placements?.selected)?.length === 0 &&
            vmPlacementIds.length > 0)
    ) {
        return (
            <Flex
                justify="center"
                align="center"
                style={{
                    height: '100%',
                    width: '100%',
                }}
            >
                <Spin size="large" />
            </Flex>
        );
    } else {
        if (vmPlacementIds.length > 0) {
            return (
                <Flex vertical gap={16}>
                    <TopSponsorsCard />
                    <VerbalMentionsTable />
                </Flex>
            );
        } else {
            return (
                <Flex
                    justify="center"
                    align="center"
                    style={{
                        height: '100%',
                        width: '100%',
                    }}
                >
                    <Alert
                        message={t(
                            'broadcastExposure.verbalMentions.noPlacementsFound.message',
                        )}
                        description={t(
                            'broadcastExposure.verbalMentions.noPlacementsFound.description',
                        )}
                        type="error"
                    />
                </Flex>
            );
        }
    }
};

export default BroadcastVerbalMentions;
